import Vue from "vue";
import Vuex from "vuex";

// Modules
import ecommerceStoreModule from "@/views/apps/e-commerce/eCommerceStoreModule";
import app from "./app";
import account from "./account";
import client from "./client";
import financial from "./financial";
import user from "./user";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    account,
    appConfig,
    client,
    financial,
    user,
    verticalMenu,
    "app-ecommerce": ecommerceStoreModule,
  },
  strict: process.env.DEV,
});
